import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rating-overview',
    templateUrl: './rating.overview.component.html',
    styleUrls: ['./rating.overview.component.css']
})
export class RatingOverviewComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
